
<button 
  class="point-actions__button point-actions__button--second"
  [attr.aria-label]="'Modificar duración' | translate"
  (click)="handleReplacePointClick()"
>
  @if(isLoadingResourcesOnExistingItem()){
    <ci-icon 
      class="point-actions__icon"
      type="svg" 
      name="loader-debounce" 
    ></ci-icon>
  } @else {
    <ci-icon
      class="point-actions__icon"
      name="cronologico"
      type="svg"
    ></ci-icon>
  }

  <span class="point-actions__text ci-footer-regular">
    {{ (isLoadingResourcesOnExistingItem() ? 'Buscando recursos' : 'Modificar recurso') | translate }}
  </span>
</button>